export default (input: string): string => {
  return input.replace(/<\/?[^>]+(>|$)/g, "");
};
